import { useEffect, useState } from 'react';
import Card from 'components/gruenland/atoms/card/Card';
import { GruenlandHeaderLogo } from 'components/svgr/GruenlandHeaderLogo';
import { GruenlandJuniorHeaderLogo } from 'components/svgr/GruenlandJuniorHeaderLogo';
import { TYPOGRAPHY_STORE_CARD_TITLE } from 'lib/typography';
import { Store } from './types';

interface Props {
  onStoreSelect: (store: Store | null) => void;
  stores: Store[];
}

const StoresList = ({ onStoreSelect, stores }: Props) => {
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);

  useEffect(() => {
    onStoreSelect(selectedStore);
  }, [onStoreSelect, selectedStore]);

  return stores.map((x) => (
    <Card key={x.id} className="cursor-pointer" onClick={() => setSelectedStore(x)}>
      <p className={TYPOGRAPHY_STORE_CARD_TITLE}>{x.name}</p>
      <p className="mb-4 mt-2">
        {x.city}
        <br />
        {x.addr}
      </p>
      <div className="flex gap-4">
        {x.has_grlnd && <GruenlandHeaderLogo height={24} />}
        {x.has_jr && <GruenlandJuniorHeaderLogo height={24} />}
      </div>
    </Card>
  ));
};

export default StoresList;
